import {
  Breadcrumbs as HHGBreadcrumbs,
  ThemeProps,
} from '@hhgtech/hhg-components'
import styled from 'styled-components'

const StyledHHGBreadcrumbs = styled(HHGBreadcrumbs)`
  &[data-size='sm'] {
    font-size: 12px;
  }

  div[data-last='false'] {
    > a {
      color: ${(props: ThemeProps) => props.theme.mbColors.midGray};
    }

    + div {
      position: relative;
      background-image: none;

      &:after {
        position: absolute;
        top: 0;
        left: 0;
        color: ${(props: ThemeProps) => props.theme.mbColors.midGray};
        content: '/';
      }
    }
  }

  div[data-last='true'] {
    > a {
      color: ${(props: ThemeProps) => props.theme.mbColors.dark};
    }
  }

  &.breadcrumb-tarot {
    div[data-last='false'] {
      display: flex;
      align-items: center;
      > a {
        height: 18px;
      }
      + div {
        margin-left: 12px;
        margin-right: 12px;

        &:after {
          color: ${(props: ThemeProps) => props.theme.colors.neutral100};
          content: '|';
        }
      }
    }
  }
`
export { StyledHHGBreadcrumbs as Breadcrumbs }
